import { CouponEnum, LegalEnum, LegalFormEnum, PayoffEnum, ProductCaptureGroupsEnum } from "src/app/product-capture/model/enums/product-capture.enums";

/**
 * This file is used to build the paths for the product capture fields.
 * The idea is to reduce the amount of lines we have in the form config files.
 * 
 * In the example below, we built a path for the coupon field and it's subfields.
 * e.g. CouponPaths.RATE_RESET, CouponPaths.RATE_RESET_FREQUENCY, etc.
 */

// Utility Functions and types
export type PathReturnType<T extends Object> = { [key in keyof T as ToUpperSnakeCase<key>]: string[] };

export const PathsBuilder = (root: any[], type: any): PathReturnType<typeof type> => {
  const obj = Object.keys(type).reduce((acc, key) => { 
    acc[toUpperSnakeCase(key)] = [...root, type[key]];
    return acc;
  }, { }) as PathReturnType<typeof type>;

  return obj;
}

function toUpperSnakeCase(input: string): string {
  return input.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase();
}

type ToUpperSnakeCase<T> =
  T extends `${infer First}${infer Rest}`
    ? `${First extends Uppercase<First> ? '_' : ''}${Uppercase<First>}${ToUpperSnakeCase<Rest>}`
    : T;


// Paths down here

/**
 * Coupon Paths: Payoff > Coupon > [Coupon Field]
 */
export const CouponPaths: PathReturnType<typeof CouponEnum> = PathsBuilder([
    ProductCaptureGroupsEnum.payoff,
    PayoffEnum.coupon
], CouponEnum);

/**
 * Legal Form Paths: Legal Form > Legal > [Legal Field]
 */
export const LegalFormPaths: PathReturnType<typeof LegalEnum> = PathsBuilder([
  ProductCaptureGroupsEnum.legalForm,
  LegalFormEnum.legal
], LegalEnum);

